export function formatRelative(iso: string | null, now: number = Date.now()): string {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  const diff = now - then;
  const abs = Math.abs(diff);
  const minute = 60_000;
  const hour = 60 * minute;
  const day = 24 * hour;

  let value: string;
  if (abs < minute) value = "just now";
  else if (abs < hour) value = `${Math.round(abs / minute)}m`;
  else if (abs < day) value = `${Math.round(abs / hour)}h`;
  else value = `${Math.round(abs / day)}d`;

  if (value === "just now") return value;
  return diff >= 0 ? `${value} ago` : `in ${value}`;
}

export function formatCountdown(seconds: number): string {
  if (seconds <= 0) return "soon";
  if (seconds < 60) return "<1m";
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.round(minutes / 60);
  return `${hours}h`;
}
